import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { PedologyViewControllerDelegate, PedologyViewController } from "../../Screen/Pedology/PedologyViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { PedologyViewModel } from '../../Screen/Pedology/PedologyViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class PedologyCoordinator implements IndexCoordinatorDelegate, PedologyViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geppedologia")
        return (<ProtectedRoute path="/:base/pedologia" exact={true} component={(props: any) => {
            return (<TableGenericViewController 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Pedologia"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new PedologyViewModel()
        return (<ProtectedRoute path="/:base/pedologia/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<PedologyViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppedologia") {
            navigation.history.push(`pedologia/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppedologia") {
            navigation.history.push(`pedologia/cad/${idSelection}`);
            return;
        }
    }

}